<template>
  <li class="channel-list-li" :class="{'selected': selectedClass}"
      @click.prevent='clickAction'>
      <span class="channel-position">{{ item.position }}</span>
    <div class="channel-img-wrap">
      <img :src="getChannelImagePath(item.images, 'COLOR')" alt="" class="channel-img">
    </div>
    <p class="channel-title">{{ item.name }}</p>
  </li>
</template>

<script>
import ChannelMixin from 'mixins/ChannelMixin'
import { mapActions } from 'vuex'

export default {
  name: 'Channel',
  mixins: [
    ChannelMixin
  ],
  methods: {
    ...mapActions([
      'getEpg',
      'selectChannel'
    ]),
    clickAction: function (e) {
      console.log(this.processing)
      if (!this.processing) {
        this.processing = true
        console.log('channel id', this.item.id)

        this.selectChannel(this.item)

        this.processing = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
    @import 'uc/_variables';
    @import 'uc/_mixins';

    li {
        line-height: 60px;
        height: 60px;
        position: relative;
        cursor: pointer;
        transition: all 0.3s ease;
        transform: scale3d(1, 1, 1); // Give layer to element so process to GPU
        background: transparent;
        box-shadow: 0px 0 30px 0px rgba(0, 0, 0, 0);
        -webkit-box-shadow: 0px 0 30px 0px rgba(0, 0, 0, 0);
        border: 3px solid transparent;
        @include no-selection;
            &.selected {
                border: 3px solid #1ca3ea;
            }
    }
    li:not(:last-child) {
      &:after {
        content: '';
        width: 100%;
        height: 1px;
        background: #e5e5e5;
        position: absolute;
        bottom: -4px;
        left: 0;
      }
    }
    li:hover:after,
    li.active:after {
      opacity: 0;
    }
    li:hover {
      transform: scale3D(1.08, 1.08, 1.08); // Give layer to element so process to GPU
      background: #fff;
      box-shadow: 0px 0 30px 0px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: 0px 0 30px 0px rgba(0, 0, 0, 0.1);
      z-index: 1;
    }
    ul li.active {
      border: 3px solid #1ca3ea;
    }
    .channel-img-wrap {
        min-width: 60px;
        width: 75px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 12px;
    }
    .channel-img {
        position: absolute;
        top: 0;
        left: 30px;
        right: 0;
        bottom: 0;
        max-width: 95%;
        max-height: 95%;
        margin: auto;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
        image-rendering: crisp-edges;
    }
    .channel-title {
        padding-left: 130px;
        margin-bottom: 0;
        text-transform: uppercase;
        font-size: 14px;
        color: #000;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .channel-position {
        display: inline-block;
        font-size: 14px;
        color: #000;
        position: absolute;
        left: 10px;
    }

    @media only screen and (min-width: $breakpoint2) {
        .channel-img-wrap {
            width: 104px;
        }
        .channel-img {
          left: 40px;
        }
        .channel-title {
            font-size: 16px;
            line-height: 54px;
            padding-left: 160px;
        }
        .channel-position {
            font-size: 16px;
            line-height: 54px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/containers/sections/Guide/Channel.vue